import { render, staticRenderFns } from "./CookieConsent.vue?vue&type=template&id=0ff4e118&scoped=true&"
import script from "./CookieConsent.vue?vue&type=script&lang=ts&"
export * from "./CookieConsent.vue?vue&type=script&lang=ts&"
import style0 from "./CookieConsent.vue?vue&type=style&index=0&id=0ff4e118&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff4e118",
  null
  
)

export default component.exports